import React from 'react';
import PropTypes from 'prop-types';
import enhanceWithClickOutside from 'react-click-outside';

class Toggle extends React.Component {
  state = {
    isShow: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShow } = this.state;
    const { canEscToClose } = this.props;

    if (isShow && !prevState.isShow && canEscToClose) {
      window.addEventListener('keyup', this.onKeyUp);
    }

    if (!isShow && prevState.isShow && canEscToClose) {
      window.removeEventListener('keyup', this.onKeyUp);
    }
  }

  onKeyUp = e => {
    if (e.keyCode === 27) {
      this.setState({
        isShow: false,
      });
    }
  };

  toggle = () => {
    this.setState({ isShow: !this.state.isShow });
  };

  showHide = isShow => {
    this.setState({ isShow });
  };

  handleClickOutside = e => {
    if (this.state.isShow) {
      this.setState({ isShow: false });
    }
  };

  getClassName = () => {
    const { appendClassName } = this.props;

    return appendClassName.includes('position-relative')
      ? appendClassName.join(' ')
      : [...appendClassName, 'position-relative'].join(' ');
  };

  render() {
    const { renderAction, renderPopup } = this.props;
    const { isShow } = this.state;

    return (
      <div className={this.getClassName()}>
        {renderAction(this.toggle)}
        {renderPopup(this.showHide, isShow)}
      </div>
    );
  }
}

Toggle.propTypes = {
  renderAction: PropTypes.func.isRequired,
  renderPopup: PropTypes.func.isRequired,
  appendClassName: PropTypes.array,
  canEscToClose: PropTypes.bool,
  onIsShowChange: PropTypes.func,
};

Toggle.defaultProps = {
  renderAction: () => {},
  renderPopup: () => {},
  appendClassName: [],
  canEscToClose: false,
};

export default enhanceWithClickOutside(Toggle);
